import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    static get targets() {
        return ['value', 'input', 'category','documentType', 'error']
    }

    connect() {
    }

    display(event) {

        const fileName = event.target.value.split('\\').pop();
        this.valueTarget.innerHTML = fileName;

        // Hide error message when file is selected
        if (this.hasErrorTarget) {
            this.errorTarget.style.display = 'none';
        }

        if (this.documentTypeTarget) {
            this.documentTypeTarget.classList.remove('hidden').add('animate__animated', 'animate__fadeIn');
        }
        // get all attachment categories into an array from /attachment_categories.json
        // const attachment_categories = JSON.parse('/attachment_categories.json')
        //
        //
        // if (fileName.includes('Bewerbung')) {
        //     this.categoryTarget.value = 'Bewerbung';
        // } else if (fileName.includes('Anschreiben')) {
        //     this.categoryTarget.value = 'Lebenslauf';
        // } else if (fileName.includes('Lebenslauf')) {
        //     this.categoryTarget.value = 'Lebenslauf';
        // } else {
        //     this.categoryTarget.value = 'Sonstiges';
        // }

    }

    validate() {
        if (this.hasErrorTarget && this.inputTarget.files.length === 0) {
            this.errorTarget.style.display = 'block';
            return false;
        }
        return true;
    }
}